import React from "react";
import Layout from "../../../components/Layout";
import Libelle from "../../../_i18n/fr.json";
import Synthese from "./Synthese";

class SyntheseDossierLocationPage extends React.Component {
  render() {
    return (
      <Layout title={Libelle.pageSynthese.titre}>
        <Synthese />
      </Layout>
    );
  }
}

export default SyntheseDossierLocationPage;
